import { createContext } from 'react';
import type { User } from 'oidc-client-ts';

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isLoggingOut: boolean;
  error: Error | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  getAccessToken: () => Promise<string | null>;
  permissions: string[];
  hasPermission: (permission: string) => boolean;
  /** User roles loaded from ABP application-configuration endpoint. */
  roles: string[];
  /** ABP feature values loaded from application-configuration endpoint. */
  features: Record<string, string>;
  /** Whether features have been loaded from the server. True even if the load failed. */
  featuresLoaded: boolean;
  /**
   * True only once application-configuration was fetched successfully, so `permissions`
   * reflects the server's answer. An empty `permissions` array is only meaningful when
   * this is true — otherwise the fetch may simply have failed.
   */
  permissionsResolved: boolean;
  hasFeature: (featureName: string) => boolean;
  /** The signed-in user's tenant (firm) name, from application-configuration; null for the host. */
  currentTenantName?: string | null;
}

/**
 * Kept separate from AuthProvider so its identity remains stable when the
 * provider is hot-reloaded while lazy route modules are being loaded.
 */
export const AuthContext = createContext<AuthContextType | null>(null);
